export default __webpack_public_path__ + "static/media/simple-logo.c80b19ce.svg";